import React, {
  Component
} from 'react';
import * as Common from '../../helpers/Common';
const $ = window.$;

export default class TilePlayer extends Component {

  constructor(props) {
    super(props);
    this.state = {palayingrate:'1.0'};
  }


  //customize audio speed normal and  slow 
  slow_normal_audio_fn(id, rate) {

    let Audio = document.getElementById("myaudio" + id);
    Audio.pause();
    Audio.currentTime = 0;
    if (Audio != null) {
        if (!isNaN(Audio.duration)) {
            Audio.playbackRate = rate;
        }
    }
    this.setState({palayingrate:rate});
    this.props.onUpdate(rate);
    if(rate==='1.0')
    {
      
        setTimeout(() => {
            $('#normal_' + id).hide();
            $('#slow_' + id).show();
        },500)
        
    }    
    else
    {
      
        setTimeout(() => {
            $('#slow_' + id).hide();
            $('#normal_' + id).show();
        },500)
        
    }
   
    Audio.play();
    $('#detail-popup'+id).slideToggle('slow');
  }




  audio_play(id,palyingrate) {

    $('div[id^="pause_btn"]').removeClass("pause-icon-hover");
    $('div[id^="stop_btn"]').removeClass("stop-icon-hover");
    let Audio = document.getElementById('myaudio' + id);
    Audio.currentTime = 0;
    if (Audio != null) {
      if (!isNaN(Audio.duration)) {
       // let opt_value = document.getElementById("speed" + id);
       // let selected_val = opt_value.options[opt_value.selectedIndex].value;
        Audio.playbackRate = palyingrate;
        Audio.play();
      }
    }
    $("#play_btn" + id).addClass("play-icon-hover");

  }

  pause_audio(id) {
    $('div[id^="play_btn"]').addClass("play-icon");
    $('div[id^="play_btn"]').removeClass("play-icon-hover");
    $('div[id^="stop_btn"]').removeClass("stop-icon-hover");
    let Audio = document.getElementById('myaudio' + id);
    if (Audio != null) {
      if (!isNaN(Audio.duration)) {
        Audio.pause();
      }
    }
    $("#pause_btn" + id).addClass("pause-icon-hover");
  }


  stop_audio(aud_file, id) {
    $('div[id^="play_btn"]').addClass("play-icon");
    $('div[id^="play_btn"]').removeClass("play-icon-hover");
    $('div[id^="pause_btn"]').removeClass("pause-icon-hover");
    let Audio = document.getElementById("myaudio" + id);
    if (Audio != null) {
      if (!isNaN(Audio.duration)) {
        Audio.src = aud_file;
        Audio.pause();
        Audio.currentTime = 0;
      }
    }
    $("#stop_btn" + id).addClass("stop-icon-hover");
  }



  slow_audio(id) {
    let Audio = document.getElementById("myaudio" + id);
    if (Audio != null) {
      if (!isNaN(Audio.duration)) {
        let opt_value = document.getElementById("speed" + id);
        var selected_val = opt_value.options[opt_value.selectedIndex].value;
        Audio.playbackRate = selected_val;
      }
    }

  }

  onComplete(id) {
    this.props.onEnd(id);
  }

  doIdle(id) {
   // $('#audios'+id).show();
   // $('#wrap'+id).hide();
  }
  slownormalaudio(id)
  {
    $('#detail-popup'+id).slideToggle('slow');
  }

  render() {
    const { aud_file, mainid, gridType, audio2, wrapper_id } = this.props;

    let audio_mine = "audio/mpeg";
    let ext = aud_file.split(".").pop();
    if (ext == "m4a") {
      audio_mine = "audio/mp4";
    }



    return (
      <div id={wrapper_id} className="playing-part" style={{ display: 'none' }}>
      <div id={`detail-popup${mainid}`}  className="detail-popup" style={{ display: 'none' }} >
          <a onClick={(e) =>  this.slow_normal_audio_fn(mainid,'1.0')} ><div className="normal" id={`normal_${(mainid)}`} style={{ display: 'none' }}><span>Normal</span> <span className="no-bg"><img src="images/play-button.png"/></span></div></a>
          <a onClick={(e) =>  this.slow_normal_audio_fn(mainid,'0.5')} ><div className="slow" id={`slow_${(mainid)}`} ><span>Slow</span><span className="no-bg"><img src="images/play-button.png"/></span></div></a>
          </div>
        <div className="dots-popup">
          <a   className="dotsof" onClick={(e) => this.slownormalaudio(mainid)}><div className="dots">
            <div></div>
            <div></div>
            <div></div>
          </div>
          </a>
          
        </div>
        <div id={`audio${mainid}`} className="audio_player" >

          <div className="play-icon-hover" id={`play_btn${mainid}`} onClick={(e) => this.audio_play(mainid,this.state.palayingrate)} title="play" />
          <div className="pause-icon" id={`pause_btn${mainid}`} onClick={(e) => this.pause_audio(mainid)} title="pause/play" style={{ display: 'none' }} />
          <div type="button" id={`stop_btn${mainid}`} onClick={(e) => this.stop_audio(aud_file, mainid)} className="stop-icon" title="stop" style={{ display: 'none' }} />
          <select name={`speed${mainid}`} id={`speed${mainid}`} className="speed" style={{ width: "20px" }} onChange={(e) => this.slow_audio(mainid)}>
            <option value="1.0">Normal</option>
            <option value="0.5">Slowly</option>
          </select>
        </div>
        {audio2 == true &&
          <audio id={`myaudio${mainid}`} controls controlsList="nodownload" onEnded={(e) => this.onComplete(mainid)} style={{ display: 'none' }}>
            <source src={aud_file} type={audio_mine} />
          </audio>
        }

        {audio2 == false &&
          <audio id={`myaudio${mainid}`} onEnded={(e) => (gridType == 'Practice') ? this.onComplete(mainid) : this.doIdle(mainid)} controls controlsList="nodownload" style={{ display: 'none' }}>
            <source src={aud_file} type={audio_mine} />
          </audio>
        }
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/lr_dlr_components/grid_partials/TilePlayer.js